module.exports = __webpack_public_path__ + "static/img/13.bde2569.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/13.jpeg
// module id = d5YM
// module chunks = 0